import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import AwesomeSlider from "react-awesome-slider";
import AwesomeSliderStyles from "../scss/light-slider.scss";
import AwesomeSliderStyles2 from "../scss/dark-slider.scss";
import "react-awesome-slider/dist/custom-animations/scale-out-animation.css";
import Image from 'material-ui-image'
import { 
  trackProjectModalClose, 
  trackProjectLinkClick 
} from "../utils/analytics";
class ProjectDetailsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false
    };
    this.modalOpenTime = null;
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data && this.props.data) {
      this.setState({ isLoading: false });
    }
    
    // Track when modal opens
    if (this.props.show && !prevProps.show) {
      this.modalOpenTime = Date.now();
    }
    
    // Track when modal closes
    if (!this.props.show && prevProps.show && this.modalOpenTime) {
      const timeSpent = Math.round((Date.now() - this.modalOpenTime) / 1000);
      trackProjectModalClose(this.props.data?.title, timeSpent);
      this.modalOpenTime = null;
    }
  }

  trackLinkClick = (linkType, url) => {
    trackProjectLinkClick(this.props.data?.title, linkType, url);
  };
  
  componentDidMount() {
    this.setState({ isLoading: false });
  }
  
  handleImageLoad = () => {
    this.setState({ isLoading: false });
  };
  
  handleImageError = () => {
    this.setState({ isLoading: false });
  };
  
  handleSlideChange = () => {
    this.setState({ isLoading: true });
    // Auto hide after 2 seconds as fallback
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 2000);
  };
  
  render() {
    if (this.props.data) {
      const technologies = this.props.data.technologies;
      const images = this.props.data.images;
      var title = this.props.data.title;
      var description = this.props.data.description;
      var url = this.props.data.url;
      var playstore = this.props.data.playstore;
      var appstore = this.props.data.appstore;
      if (this.props.data.technologies) {
        var tech = technologies.map((icons, i) => {
          return (
            <li className="list-inline-item mx-3" key={i}>
              <span>
                <div className="text-center">
                  <i className={icons.class} style={{ fontSize: "300%" }}>
                    <p className="text-center" style={{ fontSize: "30%" }}>
                      {icons.name}
                    </p>
                  </i>
                </div>
              </span>
            </li>
          );
        });
        if (this.props.data.images) {
          var img = images.map((elem, i) => {
            return (
              <div
                key={elem}
                style={{
                  alignSelf: "center",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "transparent",
                  flex: 1,
                  width: "100%",
                  height: "100%",
                }}
              >
                <img
                  src={elem}
                  alt={`Project image ${i + 1}`}
                  style={{
                    alignSelf: "center",
                    display: "flex",
                    flex: 1,
                    objectFit: "contain",
                  }}
                  onLoad={this.handleImageLoad}
                  onError={this.handleImageError}
                />
              </div>
            );
          });
        }
      }
    }
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-inside"
      >
        <div className="col-md-12">
          <span onClick={this.props.onHide} className="modal-close">
            <i className="fas fa-times fa-3x close-icon"></i>
          </span>
          <div className={`slider-container ${this.state.isLoading ? 'loading' : ''}`}>
            <AwesomeSlider
              cssModule={[AwesomeSliderStyles, AwesomeSliderStyles2]}
              animation="scaleOutAnimation"
              className="slider-image"
              bullets={false}
              organicArrows={true}
              fillParent={true}
              onTransitionStart={this.handleSlideChange}
            >
              {img}
            </AwesomeSlider>
          </div>
          <div className="mx-auto">
            <h3 style={{ padding: "5px 5px 0 5px" }}>
              {title}
              {url ? (
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link-href"
                  onClick={() => this.trackLinkClick('website', url)}
                >
                  <i
                    className="fas fa-external-link-alt"
                    style={{ marginLeft: "10px" }}
                  ></i>
                </a>
              ) : null}
            </h3>

            <div className="store-links-container">
              {playstore ? (
                <h5>
                  <a
                    href={playstore}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-href"
                    onClick={() => this.trackLinkClick('playstore', playstore)}
                  >
                    {"PlayStore link"}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                </h5>
              ) : null}
              {appstore ? (
                <h5>
                  <a
                    href={appstore}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-href"
                    onClick={() => this.trackLinkClick('appstore', appstore)}
                  >
                    {"AppStore link"}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                </h5>
              ) : null}
              {this.props.data.playstoreformech ? (
                <h5>
                  <a
                    href={this.props.data.playstoreformech}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-href"
                    onClick={() => this.trackLinkClick('playstore_mechanic', this.props.data.playstoreformech)}
                  >
                    {"PlayStore link for Mechanic app"}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                </h5>
              ) : null}
              {this.props.data.appstoreformech ? (
                <h5>
                  <a
                    href={this.props.data.appstoreformech}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-href"
                    onClick={() => this.trackLinkClick('appstore_mechanic', this.props.data.appstoreformech)}
                  >
                    {"AppStore link for Mechanic app"}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                </h5>
              ) : null}
              {this.props.data.playstoreforcust ? (
                <h5>
                  <a
                    href={this.props.data.playstoreforcust}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-href"
                    onClick={() => this.trackLinkClick('playstore_customer', this.props.data.playstoreforcust)}
                  >
                    {"PlayStore link for Customer App"}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                </h5>
              ) : null}
              {this.props.data.appstoreformcust ? (
                <h5>
                  <a
                    href={this.props.data.appstoreformcust}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-href"
                    onClick={() => this.trackLinkClick('appstore_customer', this.props.data.appstoreformcust)}
                  >
                    {"AppStore link for Customer App"}
                    <i
                      className="fas fa-external-link-alt"
                      style={{ marginLeft: "10px" }}
                    ></i>
                  </a>
                </h5>
              ) : null}
            </div>
            <p className="modal-description">{description}</p>
            <div className="col-md-12 text-center">
              <ul className="list-inline mx-auto">{tech}</ul>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ProjectDetailsModal;
